import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'


import headers from './components/headers.vue'
Vue.component('headers', headers);

import footers from './components/footers.vue'
Vue.component('footers', footers);

import destinasiLainnya from './components/destinasiLainnya.vue'
Vue.component('destinasiLainnya', destinasiLainnya);

import fotoLainnya from './components/fotoLainnya.vue'
Vue.component('fotoLainnya', fotoLainnya);

import kegiatanLainnya from './components/kegiatanLainnya.vue'
Vue.component('kegiatanLainnya', kegiatanLainnya);

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyB3M_gRmAswTKTgMdhtvbhsAbt1CQi0Ic4',
    // key: 'AIzaSyBBjXMFBzx9GhDAYY9PZqGMXaYimkcYrsQ',
    // key: 'AIzaSyC-CK-C9E_OOkeMe9IkN-Jcj2Np0n3p_ho',
    // key: 'AIzaSyCeruFEuuoqQMkcvmdkNJz77O-tN_W4KII',
    key: 'AIzaSyAFy6yhuG0aY6sArC9cpXgcHPolmBgwNXU',
    v: '3.26',
    libraries: 'places, drawing, visualization',  // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  autobindAllEvents: true,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  // installComponents: true
  installComponents: true
})

//

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
